// Admin API client — /admin/feature-status/* (mirrors the API's feature-status aggregate).

import type {
  FeatureOwner,
  ComingSoonDetail,
  FeatureStatusRecord,
  FeatureStatusValue,
  WaitingListNotifyResult,
} from '@a7y/types';
import { client } from './transport';

export const featureStatusApi = {
  // A7Y-3004: Beta / New feature status. `newUntil` is computed server-side and
  // is never accepted from the client; `docsStatus` is a compiled docs-only
  // field and is not exposed here at all.
  //
  // A7Y-3046 adds `coming_soon`: `comingSoon` carries the admin-authored
  // teaser content, and the response carries the outcome of the waiting-list
  // send that a flip AWAY from `coming_soon` triggers.
  getFeatureStatus: () =>
    client.get<{ records: Record<string, FeatureStatusRecord> }>('/feature-status'),
  /** A7Y-3046: waiting-list size per feature key, for the read-only Waiting
   *  column. Unthresholded (this is the admin surface); the product-facing
   *  count the teaser page shows is withheld below a floor server-side. */
  getFeatureStatusWaiting: () =>
    client.get<{ counts: Record<string, number> }>('/feature-status/waiting'),
  updateFeatureStatus: (
    featureKey: string,
    data: {
      status: FeatureStatusValue;
      reviewBy?: string;
      knownGaps?: string[];
      owner?: FeatureOwner;
      comingSoon?: ComingSoonDetail;
    }
  ) =>
    client.post<{
      message: string;
      featureKey: string;
      record: FeatureStatusRecord;
      /** Present only when this save drained the waiting list. */
      notification?: WaitingListNotifyResult;
    }>(`/feature-status/${featureKey}`, data),
};
